import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { fetchWithCSRFTokenForRequestObject } from "Utils/fetchWithCSRFToken";
import { BeneficiaryPair, BeneficiaryPairEditable } from "Utils/types";

import { appendAuthParams } from "Common/TokenAuth/Utils";

interface EmployeeFormIDArgs {
  employeeFormID: string | number;
}
interface BeneficiaryPairResponse {
  beneficiaryPair: BeneficiaryPair;
}

interface UpdateBeneficiaryPairArgs {
  employeeFormID: string | number;
  beneficiaryPair: BeneficiaryPairEditable;
}

export const beneficiaryPairsApi = createApi({
  reducerPath: "beneficiaryPairsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "/api/v2/",
    fetchFn: fetchWithCSRFTokenForRequestObject,
  }),

  endpoints: (builder) => ({
    getBeneficiaryPair: builder.query<BeneficiaryPairResponse, EmployeeFormIDArgs>({
      query: ({ employeeFormID }) => {
        return appendAuthParams(`employee_forms/${employeeFormID}/beneficiary_pairs`);
      },
      providesTags: ["BeneficiaryPair"],
    }),

    updateBeneficiaryPair: builder.mutation<BeneficiaryPairResponse, UpdateBeneficiaryPairArgs>({
      query: ({ employeeFormID, beneficiaryPair }) => ({
        url: appendAuthParams(`employee_forms/${employeeFormID}/beneficiary_pairs`),
        method: "put",
        body: { beneficiaryPair },
      }),
      invalidatesTags: ["BeneficiaryPair"],
    }),
  }),

  tagTypes: ["BeneficiaryPair"],
});

export const { useGetBeneficiaryPairQuery, useUpdateBeneficiaryPairMutation } = beneficiaryPairsApi;
